import { render } from "./demoInner.vue?vue&type=template&id=48f356a3"
import script from "./demoInner.vue?vue&type=script&lang=js"
export * from "./demoInner.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__